import { render, staticRenderFns } from "./ProgramPreview.vue?vue&type=template&id=8fbcf208&scoped=true"
import script from "./ProgramPreview.vue?vue&type=script&lang=js"
export * from "./ProgramPreview.vue?vue&type=script&lang=js"
import style0 from "./ProgramPreview.vue?vue&type=style&index=0&id=8fbcf208&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fbcf208",
  null
  
)

export default component.exports